import type { HistoryItem } from "../api";
import { IconStar } from "../icons";
import { LoadError, Skeleton } from "../ui";
import { ReadingRow } from "./MyReadings";

interface Props {
  items: HistoryItem[] | null;
  failed: boolean;
  onRetry: () => void;
  onOpen: (item: HistoryItem) => void;
  onToggleFavorite: (item: HistoryItem) => void;
}

/** Вкладка «Избранное»: разборы, отмеченные звёздочкой. Синхронизируется с сервером. */
export function Favorites({ items, failed, onRetry, onOpen, onToggleFavorite }: Props) {
  const favs = items?.filter((i) => i.favorite) ?? [];
  return (
    <div className="warm">
      <div className="pagehead">
        <h1>Избранное</h1>
        <p>Разборы, к которым хочется вернуться</p>
      </div>
      <div className="sheet" style={{ minHeight: "60vh" }}>
        {!items && !failed && <Skeleton rows={3} tall />}
        {failed && !items && <LoadError text="Не удалось загрузить список." onRetry={onRetry} />}
        {items && favs.length === 0 && (
          <div className="empty">
            <IconStar />
            <p style={{ marginTop: 12 }}>Пока ничего не сохранено. Нажми звёздочку в шапке любого разбора — он появится здесь.</p>
          </div>
        )}
        {favs.map((i) => (
          <ReadingRow key={i.moduleId} item={i} onOpen={onOpen} onToggleFavorite={onToggleFavorite} />
        ))}
      </div>
    </div>
  );
}
